"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../../../utils/styles");

var _stylesModule = _interopRequireDefault(require("./styles.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Select = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
      disabled = props.disabled,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      onChange = props.onChange,
      hasValue = props.hasValue,
      hasError = props.hasError,
      name = props.name,
      id = props.id,
      options = props.options,
      placeholder = props.placeholder,
      value = props.value;

  var classes = _classnames.default.apply(void 0, [_stylesModule.default.select, className, 'rounded-lg border-2 border-solid border-gray-200 py-3 pl-3 pr-8 w-full', 'appearance-none tracking-wider font-normal uppercase', 'focus:outline-none focus:shadow-base'].concat(_toConsumableArray((0, _styles.getStyleClasses)(hasValue, disabled)), [hasError && "border-red-400 ".concat(_stylesModule.default.select__error)]));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("select", {
    ref: ref,
    id: id,
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    className: classes,
    name: name,
    value: value
  }, /*#__PURE__*/_react.default.createElement("option", {
    disabled: true,
    value: ""
  }, placeholder), options.map(function (option) {
    var label = option.label;
    return /*#__PURE__*/_react.default.createElement("option", {
      disabled: option.disabled,
      key: option.value,
      value: option.value
    }, label);
  })));
});

Select.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  hasValue: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  options: _propTypes.default.array,
  placeholder: _propTypes.default.string
};
var _default = Select;
exports.default = _default;